import { ElementPermission } from '../../../core/domain/permission-types';
import { IBasicUser } from '../../core/models/basic-user.model';
import { IDcMetadataResponse } from '../../core/models/metadata.model';
import { IPublicMetadata } from './public-metadata.model';
import { ISubscriptionHistory } from './subscription-history.model';
import { ISubscriptionProfile } from './subscription-profile.model';

interface ISubscriptionDatablock {
	id: number;
	label?: string;
}

export enum HistoryStatusModel {
	UNPUBLISHED = 'UNPUBLISHED',
	AVAILABLE = 'AVAILABLE',
	UNAVAILABLE = 'UNAVAILABLE',
	SUSPENDED = 'SUSPENDED',
	RUNNING = 'RUNNING',
	WAITING = 'WAITING',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	FAILED = 'FAILED',
	UNKNOWN = 'UNKNOWN',
}

export const enum SubscriptionFields {
	Label = 'label',
	Code = 'code',
	Description = 'description',
	CreatedBy = 'createdBy',
	UpdatedBy = 'updatedBy',
	DatablockLabel = 'datablockLabel',
	DatablockId = 'datablockId',
	Status = 'status',
	Tags = 'tags',
}

export const enum SubscriptionSyncStatus {
	IN_SYNC = 'IN_SYNC',
	MODIFIED = 'MODIFIED',
	ADDED = 'ADDED',
	REMOVED = 'REMOVED',
}

export const enum SubscriptionColumnStatus {
	DELETED = 'DELETED',
	TYPE_CHANGED = 'TYPE_CHANGED',
	IS_LIST_STATUS_CHANGED = 'IS_LIST_STATUS_CHANGED',
	LABEL_CHANGED = 'LABEL_CHANGED',
	NEW_COLUMN = 'NEW_COLUMN',
}

export interface ISubscriptionResponse {
	id: number;
	uuid?: string;
	metadata?: IDcMetadataResponse;
	datablock?: ISubscriptionDatablock;
	status?: HistoryStatusModel;
	last_activation_date?: string;
	row_count?: number;
	nbr_of_cols?: number;
	duration_ms?: number;
	last_updated_by?: IBasicUser;
	public_metadata?: IPublicMetadata;
	draft_configuration?: ISubscriptionSnapshot;
	history?: Array<ISubscriptionHistory>;
	permissions?: Record<ElementPermission, boolean>;
}

export interface ISubscriptionSnapshot {
	profiles?: Array<ISubscriptionProfile>;
	drafted_by?: IBasicUser;
	update_date?: string;
	snapshot_diff?: SubscriptionSyncStatus;
}

enum SubscriptionStatus {
	Unpublished = 'UNPUBLISHED',
}

type SubscriptionStatusType = SubscriptionStatus[keyof SubscriptionStatus];

export type UsableSubscriptionResp = {
	/** La ligne DataLink, qui nomme aussi la version productrice. Plusieurs lignes partagent un uuid. */
	id: number;
	uuid: string;
	metadata: IDcMetadataResponse;
	datablock: { id: number; label: string };
	status: SubscriptionStatusType;
	last_updated_by: { unknown: boolean; name: string };
	public_metadata: {
		title: string;
		details: string;
		keywords: ReadonlyArray<string>;
	};
	version?: string;
	visible_in_catalog: boolean;
};

/**
 * A reference to a column, used in comparison-mode multi-select value_list
 * entries on the wire.
 */
export interface WireColumnRef {
	isColumn: true;
	columnId: string;
}

export interface FilterPayloadReq {
	label: string;
	description: string;
	filter: RuleFilterPayloadReq;
}

export interface RuleFilterPayloadReq {
	field?: string;
	operator?: string;
	type?: string;
	value?: string | Array<string>;
	value_column_id?: string;
	value_column_id2?: string;
	column_alias?: string;
	condition?: string;
	ign_case?: boolean;
	rules?: Array<RuleFilterPayloadReq>;
	value_list?: Array<string | number | WireColumnRef>;
}
